import type { IntentSuggestionAcceptMode, IntentSuggestionDto } from './schema';
import { INTENT_SUGGESTION_ACCEPT_MODE } from './schema';

export type AcceptIntentSuggestionResult =
  | { action: 'fill'; text: string }
  | { action: 'auto_send'; text: string };

/**
 * Single accept path so MVP fill ↔ auto_send can flip after human testing.
 */
export function acceptIntentSuggestion(
  suggestion: Pick<IntentSuggestionDto, 'insertText'>,
  mode: IntentSuggestionAcceptMode = INTENT_SUGGESTION_ACCEPT_MODE,
): AcceptIntentSuggestionResult {
  const text = suggestion.insertText.trim();
  if (mode === 'auto_send') {
    return { action: 'auto_send', text };
  }
  return { action: 'fill', text };
}
